<template>
    <div class="d-flex justify-center fill-height page">
        <v-container class="d-flex justify-center align-start flex-column mx-6">
            <v-card class="form-wrapper bordered pb-8" flat :key="1">
                <v-form ref="codeForm" @submit.prevent="verifyEmailAction">
                    <v-card-title class="font-weight-bold justify-center orange--text text--darken-2 mb-2 text-center">تأكيد البريد الإلكتروني</v-card-title>
                    <v-card-subtitle class="grey--text details-text text-center mb-2 mx-4">أرسلنا رمز من 4 أرقام إلى بريدك الإلكتروني</v-card-subtitle>
                    <digits-input color="orange darken-2" :loading="loading" :auto-focus="true" @change="updateCode" />
                    
                    <v-btn text small :disabled="sendLoading" :loading="sendLoading" class="my-4" @click="sendCodeAgain">لم تستلم الرمز؟ إرسال مرة أخرى</v-btn>
                    <v-btn type="submit" block depressed large :disabled="!code || code.length !== 4 || loading" :loading="loading" color="orange darken-2" class="white--text mt-5" @click.prevent="verifyEmailAction">التحقق من الرمز</v-btn>
                </v-form>
            </v-card>

            <div class="footer mx-auto py-3">
                <!--<v-btn text :disabled="loading" large @click="logout">
                    تسجيل الخروج
                    <v-icon right>mdi-arrow-left</v-icon>
                </v-btn>-->
                <v-btn text :disabled="loading" large @click="goBack">
                    الرجوع للخلف
                    <v-icon right>mdi-arrow-left</v-icon>
                </v-btn>
            </div>
        </v-container>
    </div>
</template>

<script>

// @ is an alias to /src
import digitsInput from '../components/default/digits-input'
export default {
    name: 'Confirm',
    data(){
        return {
            loading: false,
            sendLoading: false,
            code: '',
        };
    },
    components: {
        digitsInput
    },
    computed:{
        appLoadedOnce(){
            return this.$store.state.loaded;
        },
        user(){
            return this.$store.state.userModule.user;
        },
    },
    methods: {
        verifyEmailAction(){
            // const self = this;
            let code = this.code,
                pattern = /^[0-9]{4}$/g;
            // check if reponse if parseInt for code is int, and length = 4
            if (code && pattern.test(code.toString())){
                
                this.loading = true;
                this.$store.dispatch('verifyEmailAction', {code}).then(response=>{
                    this.loading = false;
                    if (response.status === 209){
                        this.showMsg("تم تأكيد البريد الإلكتروني من قبل", 'success');
                    }else{
                        this.showMsg("تم تأكيد البريد الإلكتروني بنجاح", 'success');
                    }
                    window.setTimeout(()=>{
                        this.$router.push({name: 'home'});
                    }, 500);
                }).catch(error=>{
                    // this.$refs.codeForm.reset();
                    if (error.response && (error.response.status === 401 || error.response.status === 404 )){
                        this.showMsg("الرمز الذي أدخلته غير صحيح");
                    }else{
                        this.showMsg("حدثت مشكلة أثناء فحص الرمز، حاول لاحقاً");
                    }
                    
                    this.loading = false;
                })
                
            }else{
                this.showMsg("أدخل الرمز بشكل صحيح (مكون من 4 أرقام)");
            }
        },
        sendCodeAgain(){
            this.sendLoading = true;
            this.$store.dispatch('sendCodeAgain').then(()=>{
                this.sendLoading = false;
                this.showMsg("تم إرسال الرمز مرة أخرى إلى بريدك الإلكتروني", 'grey darken-3');
            }).catch(()=>{
                this.showMsg("حدثت مشكلة أثناء إرسال الرمز مرة أخرى");
                this.sendLoading = false;
            })
        },
        updateCode(code){
            this.code = code;
        },
        showMsg(text, color = 'error', timeout = 4000){
            this.$store.dispatch('addSnackMsg', {show: true, text: text, color: color, timeout: timeout, msgBar: true});
        },
        closeMsg(){
            if (this.$store.state.globalModule.snackMsg.text){
                this.$store.dispatch('addSnackMsg', {show: false, text: '', msgBar: true});
            }
        },
        logout(){
            this.$store.dispatch('logout');
        },
        goBack(){
            this.$router.go(-1);
            // this.$router.push({path: '/'});
        },
    },
    watch: {
        code(){
            // this.closeMsg();
        }
    },
    mounted(){
        // redirect if already confirmed
        if (this.user.email_verified_at){
            this.showMsg("تم تأكيد البريد الإلكتروني من قبل", 'grey darken-3');
            this.$router.push({name: 'home'});
        }
    }
}
</script>

<style lang="scss" scoped>
    .logo-wrapper{
        height: 30vh;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .logo{
            max-width: 150px;
            min-width: 120px;
            height: auto;
        }
    }
    .form-wrapper{
        width: 100%;
        text-align: center!important;
        
        @media (min-width: 960px){
            width: 400px;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>